<template>
  <div style="background-color:white">
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline "
          style="float:right!important">
          <el-form-item :label="lable.drdw">
            <el-cascader
              v-model="deviceInfo.transferIn"
              style="width: 140px"
              :options="options"
              :props="companyProps"
              clearable
              :show-all-levels="false"
              filterable
              :placeholder="'请选择' + lable.drdw"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker v-model="deviceInfo.date" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="模糊搜索">
            <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="请输入搜索内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="allocationData" tooltip-effect="dark"
          style="width: 100%;text-align: center" stripe>
          <el-table-column prop="id" :label="lable.id" width="170">
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link :underline="false" @click="selectClick(scope.row)" style="color: #4095E5;text-decoration: none;">
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="sqrq" :label="lable.sqrq" :formatter="formateTime" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="drdw" :label="lable.drdw" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="dcdw" :label="lable.dcdw" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="userName" :label="lable.userName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="dbly" :label="lable.dbly" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="statue" :label="lable.statue" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.statue == '4'" style="color:#4095E5">待审核</span>
              <span v-else-if="scope.row.statue == '2'" style="color:rgb(204, 169, 13)">驳回</span>

              <span v-else-if="scope.row.statue == '5'" style="color:coral">待调拨</span>
              <span v-else-if="scope.row.statue == '7'" style="color:gray">待调出确认</span>
              <span v-else-if="scope.row.statue == '8'" style="color:gray">待调入确认</span>
              <span v-else-if="scope.row.statue == '9'" style="color:yellowgreen">调拨完成</span>
              <span v-else-if="scope.row.statue == '0'" style="color:red">驳回</span>
            </template>
          </el-table-column>
          <el-table-column :label="lable.cz" show-overflow-tooltip>
            <template slot-scope="scope">

              <el-button v-if="scope.row.statue == '5' && show.xzdb" @click="openWinder(scope.row)" type="text"
                size="small">选择调拨</el-button>
              <el-button @click="selectClick(scope.row)" type="text" size="small">详情</el-button>

            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="allocationData.length > 0" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>
    <!--------------------------------------------------------------------调拨详情弹框--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible3" title="调拨详情" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:100% !important;margin-left: 100px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left:5%;">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.dcdw" style="width:90%">
              <el-input v-model="questionForm.dcdw" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.drdw">
              <el-input v-model="questionForm.drdw" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width:90%">
              <el-input v-model="questionForm.userName" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请部门">
              <el-input v-model="questionForm.companyName" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.sqrq" style="width:90%">
              <el-input v-model="questionForm.sqrq" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.statue" prop="">
              <el-input :readonly="true" v-model="questionForm.wz" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="审核结果" style="width:90%">
              <el-input :readonly="true" v-model="inForm.shjg" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核意见">
              <el-input :readonly="true" v-model="inForm.shyj" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.dbly" prop="dbly">
          <el-input type="textarea" :rows="2" :readonly="true" v-model="questionForm.dbly" />
        </el-form-item>
        <el-form-item label="资产列表" prop="correctAnswer">
          <el-table :data="assetsData" :border="true" style="width: 100%;text-align: center" size="mini"
            max-height="235px" :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcbh" label="资产编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="sbxh" label="规格型号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ssdw" label="所属单位" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table :data="fileData" :border="true" style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot-scope="scope">
                <el-button @click="yulan(scope.row)" type="text" size="small">预览</el-button>
                <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" type="primary" @click="dialogFormVisible3 = false">确定</el-button>
      </div>
    </el-dialog>
    <!------------------------------------------------------------------------------选择调拨----------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible6" title="调入申请调拨" size="mini" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:110% !important;">
      <el-form :model="inForm" ref="dataForm" label-position="left" label-width="100px" style="width: 100%">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.id" style="width:90%">
              <el-input :readonly="true" v-model="inForm.id" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.drdw" prop="dbly">
              <el-input :readonly="true" v-model="inForm.drdw" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width:90%">
              <el-input :readonly="true" v-model="inForm.userName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请部门">
              <el-input :readonly="true" v-model="inForm.companyName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.sqrq" style="width:90%">
              <el-input :readonly="true" v-model="inForm.sqrq" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.dbly" prop="dbly">
              <el-input :readonly="true" v-model="inForm.dbly" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="审核结果" style="width:90%">
              <el-input :readonly="true" v-model="inForm.shjg" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核意见">
              <el-input :readonly="true" v-model="inForm.shyj" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12"> -->
        <el-form-item label="需求列表" prop="correctAnswer">
          <el-table :data="transfersData" :border="true" style="width: 100%;" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="deviceTypeName" label="资产分类" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="sl" label="数量" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="lc" label="量程" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="jddj" label="精度等级" show-overflow-tooltip>
            </el-table-column>
            <!-- <el-table-column prop="dbsl" label="已调拨数量" show-overflow-tooltip>
                </el-table-column> -->
          </el-table>
        </el-form-item>
        <!-- </el-col>
          <el-col :span="12"> -->
        <el-form-item label="资产列表">
          <el-table :data="assetsAllData" :border="true" style="width: 100%;text-align: center" size="mini"
            max-height="235px" :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcbh" label="资产编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column prop="sbxh" label="规格型号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ssdw" label="所属单位" show-overflow-tooltip>
            </el-table-column>
            <el-table-column show-overflow-tooltip>
              <template slot="header" slot-scope="scope">
                <DC :transferValue="transferValue" :personInfo="0" ></DC>
              </template>
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!-- </el-col>
        </el-row> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="determine" v-preventReClick>确认完成</el-button>
        <el-button @click="dialogFormVisible6 = false">取消</el-button>
      </div>
    </el-dialog>

    <!------------------------------------------------------------------------------调入详情----------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible7" title="调入申请详情" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:110% !important;">
      <el-form :model="inForm" ref="dataForm" size="mini" label-position="left" label-width="100px" style="width: 100%">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.id" style="width:90%">
              <el-input :readonly="true" v-model="inForm.id" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.drdw" prop="dbly">
              <el-input :readonly="true" v-model="inForm.drdw" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width:90%">
              <el-input :readonly="true" v-model="inForm.userName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请部门" prop="dbly">
              <el-input :readonly="true" v-model="inForm.companyName" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.sqrq" style="width:90%">
              <el-input :readonly="true" v-model="inForm.sqrq" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.dbly" prop="dbly">
              <el-input :readonly="true" v-model="inForm.dbly" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="审核结果" style="width:90%">
              <el-input :readonly="true" v-model="inForm.shjg" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核意见">
              <el-input :readonly="true" v-model="inForm.shyj" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="需求列表">
              <el-table :data="transfersData" :border="true" style="width: 90%;" size="mini" max-height="235px"
                :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
                <el-table-column prop="deviceTypeName" label="资产分类" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="sl" label="数量" width="50" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="lc" label="量程" width="50" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="jddj" label="精度等级" width="70" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="dbsl" label="已调拨数量" show-overflow-tooltip>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="资产列表">
              <el-table :data="assetsAllData" :border="true" style="width: 100%;text-align: center" size="mini"
                max-height="235px" :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
                :cell-style="{ textAlign: 'center' }">
                <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="zcbh" label="资产编号" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="id" v-if="false"> </el-table-column>
                <el-table-column prop="sbxh" label="规格型号" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="ssdw" label="所属单位" show-overflow-tooltip>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="调拨列表">
          <el-table :data="allData" :border="true" style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="id" label="调拨id" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="dcdw" label="调出试验室" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="shjg" label="审核结果" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="shyj" label="审核意见" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="statue" label="调拨状态" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.statue == '4'" style="color:#4095E5">待审核</span>
                <span v-else-if="scope.row.statue == '2'" style="color:rgb(204, 169, 13)">撤回</span>

                <span v-else-if="scope.row.statue == '5'" style="color:coral">待调拨</span>
                <span v-else-if="scope.row.statue == '7'" style="color:gray">待调出确认</span>
                <span v-else-if="scope.row.statue == '8'" style="color:gray">待调入确认</span>
                <span v-else-if="scope.row.statue == '9'" style="color:yellowgreen">调拨完成</span>
                <span v-else-if="scope.row.statue == '0'" style="color:red">驳回</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button @click="selectClick(scope.row)" type="primary" size="small">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible7 = false">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px" width="63%">
      <FilePreview ref="filePreview" />
    </el-dialog>
  </div>
</template>
<script>
import {
  findAllAllocation,
  treeCompany,
  findByIdFile,
  delByIdFile,
  upload,
  addAllocation,
  findByIdAllocation,
  findByIdDevice,
  delByIdDevice,
  selectTreeDeviceType,
  findTransferIn,
  selectByPid,
  selectAllDevice,
  findByIdTypeName,
  submitBatchId,
  findByModule,
  getBase
} from "../../api/api";
import FilePreview from '../../components/preview/FilePreview.vue'
import allcationMultiple from "../../components/common/AllocationMultiple.vue";
export default {
  name: "Select",
  components: {
    "FilePreview": FilePreview,
    "DC": allcationMultiple,
  },
  data() {
    return {
      show: {
        xzdb: false,
        xg: false,
        sc: false,
      },
      lable: {},
      deviceInfo: {
        date: [],
        content: "",
        state: "",
        transferIn: "",
        transferOut: ""
      },
      userinfo: {},
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      transfersData: [],
      allocationData: [],
      assetsData: [
      ],
      multipleTable: [],
      dialogFormVisible3: false,
      dialogFormVisible6: false,
      dialogFormVisible7: false,
      parame: {
        state: 4,
        companyCode: JSON.parse(localStorage.getItem("user")).companyCode
      },
      companyProps: {
        label: 'companyName',
        value: 'companyCode',
        children: 'zcompany',
        emitPath: false,
        checkStrictly: true,
      },
      options: [],
      questionForm: {
        transferId: [],
        deviceId: [],
        dblx: ""
      },
      inForm: {},
      number: '',
      isShow3: false,
      isShow1: true,
      isShow: false,
      transfers: [],
      innerVisible: false,
      innerVisible1: false,
      form: {
        name: "",
        fileDesc: ""
      }, docxdialog: false,
      previewTitle: '',
      fileData: [],
      fileList: [],
      questionForm1: {},
      allData: [],
      assetsAllData: []
    };
  },
  methods: {
    // 格式化时间显示到日期
    formateTime(row) {
      let nowData = new Date(row.sqrq)
      let year = nowData.getFullYear();
      let month = (nowData.getMonth() + 1).toString().padStart(2, '0');
      let date = nowData.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${date}`;
    },
    downloading(scop) {
      // debugger
      this.downloadUtil.downloadFile(scop.path, scop.name);
    },
    //确认完成
    qrwc() {
      var map = {
        id: this.inForm.id,
        userId: this.userinfo.userId
      }
      submitBatchId(map).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.$message({
            message: "调拨完成",
            type: "success"
          });
          this.findAll()
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      })
    },
    //预览
    yulan(row) {
      if (row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpg' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'png' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpeg') {
        this.previewTitle = "图片预览"
      } else {
        this.previewTitle = "文件预览"
      }
      this.docxdialog = true
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.path)
      })
    },

    //导出列表
    derive() {
      window.open(getBase()+'/excel/allocationExcel')
    },
    //选择设备弹框
    transferValue(outData) {
      for (var i = 0; i < outData.length; i++) {
        this.assetsAllData.push(outData[i]);
      }
    },
    //设备调拨弹框
    openWinder(row) {
      this.dialogFormVisible6 = true
      this.findTransfer(row.id);
      this.inForm = {}
      this.inForm = row;
      this.selectAll1(row.id)
      this.assetsAllData = [];
      this.assetsData = [];
      //查找子调拨设备信息
    },

    selectAllDvice(row) {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var map = {
        id: row,
        userId: this.userinfo.id,
      };
      selectAllDevice(row).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.assetsAllData = [];
          this.assetsAllData = data;
        }
      })
    },
    selectAll1(row) {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var map = {
        id: row,
        userId: userinfo.userId,
      };
      selectByPid(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.allData = [];
          this.allData = data;
        }
      })
    },
    //打开详情弹框
    selectClick(row) {
      if (row.dblx == 2) {
        this.dialogFormVisible7 = true;
        this.findTransfer(row.id);
        this.inForm = {};
        this.inForm = row;
        this.selectAll1(row.id);
        this.selectAllDvice(row.id);
        //查找子调拨设备信息

      } else {
        this.dialogFormVisible3 = true;
        this.findByIdfile(row.id);
        this.findByDevice(row.id);
        this.findById(row.id);
      }

    },

    //删除调拨
    delAllocation(row) {
      var map = {
        id: row.id,
        userId: this.userinfo.userId
      }
      delByIdDevice(map).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.findAll();
          if (row.allPid != null) {
            this.findTransfer(row.allPid)
            this.selectAll1(row.allPid);
            this.selectAllDvice(row.allPid);
          }
        }

      });
    },
    //删除调入设备绑定
    delDevice(row) {
      this.transfersData.splice(this.transfersData.indexOf(row), 1);

    },
    //根据单号查询调拨设备
    findByDevice(row) {
      findByIdDevice(row).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.assetsData = data;
        }
      });
    },

    //根据id调拨详情
    findById(row) {
      findByIdAllocation(row).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.questionForm = data;
        }
      });
    },
    //移除调拨资产
    handleClick(row) {
      var i =this.assetsAllData.indexOf(row);
      this.assetsAllData.splice(this.assetsAllData.indexOf(row),1);
    },


    // //打开设备调拨弹框
    // handleCreate() {
    //   this.questionForm = {
    //     deviceId: [],
    //     transferId: []
    //   };
    //   let id = "db" + +new Date();
    //   this.questionForm.id = id;
    //   this.questionForm.dblx = 0;
    //   this.fileData = [];
    //   this.assetsData = [];
    // },
    //添加设备调拨信息
    determine() {
      var m = [];
      for (let i = 0; i < this.assetsAllData.length; i++) {
        var a = this.assetsAllData[i];
        m.push(a.id);
      }
      this.questionForm.deviceId = m;
      this.userinfo = JSON.parse(localStorage.getItem("user"))

      var map = {
        deviceId: m,
        dblx: 0,
        id: "db" + +new Date(),
        pid: this.inForm.id,
        dbly: this.inForm.dbly,
        drdw: this.inForm.drdw,
        userId: this.userinfo.userId
      }
      addAllocation(map).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.findAll();
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.dialogFormVisible6 = false
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    DFile(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delByIdFile(row.id).then(datas => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.findByIdfile(this.questionForm.id);
            this.$message({
              message: message,
              type: "success"
            });
          }
        });
      })
    },
    //根据id查找文件
    findByIdfile(id) {
      findByIdFile(id).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.fileData = data;
          // debugger
        }
      });
    },
    //点击上传文件触发的额外事件,清空fileList
    delFile() {
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    //自定义上传文件
    uploadFile(file) {
      this.formData.append("file", file.file);
    },
    //删除文件
    handleRemove(file, fileList) {
    },
    // 点击文件
    handlePreview(file) {
    },
    //文件上传
    onSubmit() {
      if (this.fileList[0] == null) {
        this.$message.error("请选择上传的文件"); // .....失败信息
      } else {
        var formData = new FormData();
        formData.append("file", this.fileList[0].raw); //拿到存在fileList的文件存放到formData中
        //下面数据是我自己设置的数据,可自行添加数据到formData(使用键值对方式存储)
        formData.append("name", this.form.name);
        formData.append("fileDesc", this.form.fileDesc);
        formData.append("number", this.questionForm.id);
        var userinfo = JSON.parse(localStorage.getItem("user"))
        formData.append("userId", userinfo.userId)
        upload(formData).then(datas => {
          // debugger
          let { status, message, data } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.fileData.push(data)
            // this.findByIdfile(id);
            this.$message({
              message: '上传成功',
              type: "success"
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
          this.form.fileDesc = "";
          this.form.name = "";
          this.fileList = [];
          this.innerVisible = false;
        });
      }
    },
    //添加调入资产
    addTransferIn() {
      findByIdTypeName(this.questionForm1.zcfl).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.questionForm1.deviceTypeName = data;
          this.transfersData.push(this.questionForm1)
          this.innerVisible1 = false;
          this.questionForm1 = {
            deviceId: [],
            transferId: [],
          };
        }
      });
    },
    //根据id查找申请调入设备信息
    findTransfer(id) {
      findTransferIn(id).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.transfersData = data;
        }
      });
    },
    //查询所有单位
    selectCompany() {
      treeCompany().then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.options = this.getTreeData1(data);
        }
      });
    },
    getTreeData1(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData1(data[i].zcompany);
        }
      }
      return data;
    },
    findAllClick(){
      this.pageIndex=1
      this.findAll()
    },
    //查找所有调拨信息
    findAll() {
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        transferIn: this.deviceInfo.transferIn,
        transferOut: this.deviceInfo.transferOut,
        content: this.deviceInfo.content,
        state: 5,
        userId: this.userinfo.userId
      };
      findAllAllocation(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }
          this.allocationData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = this.data.length;
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].deviceTypes.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].deviceTypes = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].deviceTypes);
        }
      }
      return data;
    },
    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.allocationData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.allocationData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    isFromDeviceDetail() {
      let row = JSON.parse(sessionStorage.getItem("allocationData"))
      if (row != null) {
        this.selectClick(row);
        sessionStorage.removeItem("allocationData")
      }
    },
    findLable() {
      findByModule("调拨管理").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
  },
  created() {
    this.findLable();
    this.findAll();
    this.selectCompany();
    // this.selectDeviceType();
    this.isFromDeviceDetail();
    this.userinfo = JSON.parse(localStorage.getItem("user"))
    var arr = this.userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "82") {
        this.show.xzdb = true;
      }
      if (i == "102") {
        this.show.xg = true;
      }
      if (i == "103") {
        this.show.sc = true;
      }
      if (i == "202") {
        this.show.ch = true;
      }
    })
    // this.rw();
    if (this.userinfo.userRole == 1 || (this.userinfo.companyCode != null && this.userinfo.companyCode == "G065")) {
      this.isShow1 = false;
    }
  }
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}

;
</style>
  


// WEBPACK FOOTER //
// src/views/allocation/Select.vue